var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isPhone)?_c('consult'):_vm._e(),_c('int_new')],1)}
var staticRenderFns = []

export { render, staticRenderFns }